import { createAction, props } from '@ngrx/store';
import { LabResultEntity } from './lab-results.models';
import {
  ILabResultDTO,
  LabResultQueryDto,
  LoadType
} from '@care-portals/api-interfaces';

export const loadLabResults = createAction(
  '[LabResults] Load LabResults',
  props<{ customerId: string; filters?: LabResultQueryDto }>()
);

export const loadLabResultsSuccess = createAction(
  '[LabResults] Load LabResults Success',
  props<{
    labResults: LabResultEntity[];
  }>()
);

export const loadLabResultsFailure = createAction(
  '[LabResults] Load LabResults Failure',
  props<{ error: string | null }>()
);

export const loadAllLabResults = createAction(
  '[LabResults] Load All LabResults',
  props<{ loadType?: LoadType; filters: Partial<LabResultQueryDto> }>()
);

export const loadAllLabResultsSuccess = createAction(
  '[LabResults] Load All LabResults Success',
  props<{
    labResults: LabResultEntity[];
    loadType: LoadType;
    limit: number;
    offset: number;
  }>()
);

export const loadAllLabResultsFailure = createAction(
  '[LabResults] Load All LabResults Failure',
  props<{ error: string | null }>()
);

export const updateLabResult = createAction(
  '[LabResults] Update LabResult',
  props<{ id: string; labResult: Partial<LabResultEntity> }>()
);

export const updateLabResultSuccess = createAction(
  '[LabResults] Update LabResult Success',
  props<{ labResult: LabResultEntity }>()
);

export const updateLabResultFailure = createAction(
  '[LabResults] Update LabResult Failure',
  props<{ error: string | null }>()
);

export const setActiveLabResultId = createAction(
  '[LabResults] Set Active Lab Result ID',
  props<{ labResultId: string }>()
);

export const openLabResultPdf = createAction(
  '[LabResults] Open Lab Result PDF',
  props<{ labResultId: string }>()
);

export const openLabResultPdfSuccess = createAction(
  '[LabResults] Open Lab Result PDF Success',
  props<{ signedUrl: string }>()
);

export const openLabResultPdfFailure = createAction(
  '[LabResults] Open Lab Result PDF Failure',
  props<{ error: string | null }>()
);

// Create lab result (manual form). Optional file: backend uploads PDF and creates lab result in one request.
export const createLabResult = createAction(
  '[LabResults] Create Lab Result',
  props<{
    customerId: string;
    labResult: ILabResultDTO;
    file?: { buffer: string; name: string; mimetype: string };
  }>()
);

export const createLabResultSuccess = createAction(
  '[LabResults] Create Lab Result Success',
  props<{ labResult: LabResultEntity }>()
);

export const createLabResultFailure = createAction(
  '[LabResults] Create Lab Result Failure',
  props<{ error: string | null }>()
);

export const submitLabResultPdf = createAction(
  '[LabResults] Submit Lab Result PDF',
  props<{
    customerId: string;
    file: { buffer: string; name: string; mimetype: string };
  }>()
);

export const submitLabResultPdfSuccess = createAction(
  '[LabResults] Submit Lab Result PDF Success',
  props<{
    response: { faxId: string; fileName: string };
    customerId: string;
  }>()
);

export const submitLabResultPdfFailure = createAction(
  '[LabResults] Submit Lab Result PDF Failure',
  props<{ error: string | null }>()
);
